export type Environments = 'development' | 'staging' | 'production'

export const env = (process.env.NODE_ENV ?? 'development') as Environments

export const release = process.env.PUBLIC_RELEASE ?? ('unreleased' as string)

export const isDev: boolean = env === 'development'

export const isProd: boolean = env === 'production'

export const environment = env as Environments

export default env
